/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useMutation } from 'react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const sendMonitoringAlerts = () => {
  return customInstance<void>({ url: `/operations/tmr/alert`, method: 'POST' });
};

export const getSendMonitoringAlertsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMonitoringAlerts>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMonitoringAlerts>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMonitoringAlerts>>,
    void
  > = () => {
    return sendMonitoringAlerts();
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMonitoringAlertsMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMonitoringAlerts>>
>;

export type SendMonitoringAlertsMutationError = unknown;

export const useSendMonitoringAlerts = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMonitoringAlerts>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMonitoringAlerts>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSendMonitoringAlertsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const runTransactionMonitoring = () => {
  return customInstance<void>({
    url: `/operations/tmr/monitor`,
    method: 'POST',
  });
};

export const getRunTransactionMonitoringMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runTransactionMonitoring>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runTransactionMonitoring>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runTransactionMonitoring>>,
    void
  > = () => {
    return runTransactionMonitoring();
  };

  return { mutationFn, ...mutationOptions };
};

export type RunTransactionMonitoringMutationResult = NonNullable<
  Awaited<ReturnType<typeof runTransactionMonitoring>>
>;

export type RunTransactionMonitoringMutationError = unknown;

export const useRunTransactionMonitoring = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runTransactionMonitoring>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof runTransactionMonitoring>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRunTransactionMonitoringMutationOptions(options);

  return useMutation(mutationOptions);
};
